import { createApiSlice } from "@common";
import {
  CRUD_OPPORTUNITY_TAGGING,
  GET_OPPORTUNITY_TAGGING_BY_OPPORTUNITY_ID,
} from "@routes";

const apiConfig = [
  {
    name: "addOpportunityTagging",
    method: "post",
    url: CRUD_OPPORTUNITY_TAGGING,
    stateKey: "message",
  },
  {
    name: "getOpportunityTaggingByOpportunityId",
    method: "get",
    url: GET_OPPORTUNITY_TAGGING_BY_OPPORTUNITY_ID,
    stateKey: "details",
  },
];

const customReducers = {
  initialState: {
    data: [],
    details: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {},
};

const { slice, thunks, actions } = createApiSlice(
  "opportunityTagging",
  apiConfig,
  customReducers
);
const opportunityTaggingSlice = slice;

export default opportunityTaggingSlice.reducer;

export const {
  addOpportunityTagging,
  getOpportunityTaggingByOpportunityId,
} = thunks;

export const { setAdditionalData, rowSelect } = actions;
